import authRules from '../authRules.js';

const addAssignment = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.addAssignment.scheduleData) {
    return true;
  } else {
    return false;
  }
}

export default addAssignment;
